import $ from "jquery";
import Foundation from "foundation-sites";
import AbstractController from '../../../Controller/AbstractController';
import Controller from '../../../Controller/Controller';
import HeaderSlider from '../Elements/HeaderSlider';
import VariantSlider from '../Elements/VariantSlider';
import AnchorNavigation from '../Elements/AnchorNavigation';
import TechnicalData from '../Elements/TechnicalData';
import Notepad from '../Elements/Notepad';
import AttributesTable from '../Elements/AttributesTable';
import {$window, $body, CLEAN_URL} from '../../../Constants';

/**
 * Product Controller
 *
 * @class
 */
class ProductController extends AbstractController {
	/**
	 * @constructor
	 */
	constructor() {
		super();

		Controller.registerController(this);
		this._registerElements(...HeaderSlider, ...VariantSlider, AnchorNavigation, TechnicalData, Notepad, AttributesTable);

		// Last seen products
		this._lastProducts();

		// Webcode
		this._checkWebcodes();

		// Load prices
		this._loadPrices();

		if ($window.width() >= 1024) {
			this._initAccordionSlider();
		}
	}

	/**
	 * Get last seen products
	 *
	 * @private
	 */
	_lastProducts()
	{
		let lastProducts = $body.find('#lastProducts');
		if (lastProducts.length > 0) {
			$.ajax({
				type: 'GET',
				url: CLEAN_URL + '?type=3423&uid=' + lastProducts.data('uid'),
				success: function(response){
					lastProducts.replaceWith(response);
					// Apply equalizer manually after ajax load
					new Foundation.Equalizer($body.find('.lastProducts.row')).applyHeight();
				}
			});
		}
	}

	/**
	 * Check if webcodes can be shown
	 *
	 * @private
	 */
	_checkWebcodes()
	{
		let $webcode = $body.find('p.webcode');
		if ($webcode.length > 0) {
			$.ajax({
				type: 'GET',
				url: CLEAN_URL + '?type=3413',
				success: function(response){
					if (response == 1) {
						$webcode.show();
					}
				}
			});
		}
	}

	/**
	 * Load prices
	 *
	 * @private
	 */
	_loadPrices()
	{
		// this._loadArticlePrices();

		// Prices for accessories
		let accessories = [];
		let $accessoryPrices = $body.find('.accessory-price');
		$accessoryPrices.each(function() {
			accessories.push($(this).data('number'));
		});

		if (accessories.length > 0) {
			$.ajax({
				type: 'GET',
				dataType: 'json',
				url: CLEAN_URL + '?type=3401&c=1&a=' + accessories.toString(),
				success: function(response){
					if(Object.keys(response).length > 0) {
						$accessoryPrices.each(function() {
							let number = $(this).data('number');
							if(response[number]) {
								$(this).html(response[number]);
								// Also add price to overlay and unhide it
								$body.find('.overlay-price[data-number="' + number + '"]').html(response[number]).show();

								const $accessories = $body.find('.row.accessories');
								$accessories.removeClass('equalized');
							}
						});
					}
				}
			});
		}

		// Prices for teaser
		let teaserGroups = [];
		let teaserProducts = [];
		let $teaserPrices = $body.find('.ig-teasers span.price');
		$teaserPrices.each(function() {
			if ($(this).data('type') === 'product') {
				teaserProducts.push($(this).data('uid'));
			} else {
				teaserGroups.push($(this).data('uid'));
			}
		});

		if (teaserProducts.length > 0) {
			let uidList = teaserProducts.toString();
			this._loadTeaserPrices('product', 'p', uidList, $teaserPrices);
		}
		if (teaserGroups.length > 0) {
			let uidList = teaserGroups.toString();
			this._loadTeaserPrices('productgroup', 'g', uidList, $teaserPrices);
		}
	}

	/**
	 * Load prices for teasers
	 *
	 * @private
	 */
	_loadTeaserPrices(type, param, uidList, $teaserPrices)
	{
		$.ajax({
			type: 'GET',
			dataType: 'json',
			url: CLEAN_URL + '?type=3401&c=1&' + param + '=' + uidList,
			success: function(response){
				if(Object.keys(response).length > 0) {
					$teaserPrices.each(function(){
						if ($(this).data('type') === type) {
							let uid = $(this).data('uid');
							if(response[uid]) {
								$(this).html($(this).data('prepend') + ' ' + response[uid]);
							}
						}
					});
				}
			}
		});
	}

	_loadArticlePrices() {
		// Prices for article sizing table
		let articles = [];
		let $articlePrices = $body.find('.price span');
		$articlePrices.each(function() {
			articles.push($(this).data('number'));
		});

		if (articles.length > 0) {
			$.ajax({
				type: 'GET',
				dataType: 'json',
				url: CLEAN_URL + '?type=3401&a=' + articles.toString(),
				success: function(response){
					if(Object.keys(response).length > 0) {
						$articlePrices.each(function(){
							let number = $(this).data('number');
							if(response[number]) {
								$(this).replaceWith(response[number]);
							}
						});
						$body.find('.price').show();

						if ($window.width() >= 1024) {
							$('.article-table-wrap').data('instance').adjustScrollSpacings();
						}
					}
				}
			});
		}
	}

	_initAccordionSlider() {
		$('.accordion-slider').each(function() {
			$(this).accordionSlider({
				width: '100%',
				height: 420,
				shadow: false,
				closePanelsOnMouseOut: false,
				autoplay: false,
				startPanel: 0,
				responsiveMode: 'custom',
				maxOpenedPanelSize: $window.outerWidth() >= 1200 && $window.outerWidth() < 1600 ? '60%' : '80%',
				mouseWheel: false,
				init: () => {
					const $descriptionsContainer = $body.find('.panel-descriptions');
					const $descriptions = $body.find('.panel-descriptions .panel-description');
					const heights = [];

					$descriptions.each(function() {
						heights.push($(this).outerHeight());
					});

					$descriptionsContainer.css('height', Math.max(...heights));
				},
				panelOpen: (e) => {
					const $prevDescription = $body.find('.panel-descriptions .panel-description').eq(e.previousIndex);
					const $description = $body.find('.panel-descriptions .panel-description').eq(e.index);

					if (e.previousIndex !== -1) {
						$prevDescription.stop(true, false).fadeOut(300, () => {
							$description.css('opacity', 1);
							$description.css('z-index', 1);
							$description.fadeIn(300);
						});
					} else {
						$description.css('opacity', 1);
						$description.css('z-index', 1);
						$description.fadeIn(300);
					}
				}
			});
		});
	}
}

export default new ProductController();
